import { useMutation } from "@tanstack/react-query";
import services from "../services";

export interface PatchEstimateInput {
  estimateNo: string;
  payload: {
    /** Writes under estimate.fastest / estimate.cheapest. */
    deliveryType: "FASTEST" | "CHEAPEST";
    cptMax?: string | null;
    deliveryCostMax?: number | null;
  };
}

export const usePatchEstimate = () => {
  return useMutation({
    mutationKey: ["estimate", "patch"],
    mutationFn: (data: PatchEstimateInput) =>
      services.patchEstimate(data.estimateNo, data.payload),
  });
};
